module.exports = __webpack_public_path__ + "static/media/THE WHITE HART INTRO.f4cacc7b.pdf";